/* złoteserce: galeria, warianty, koszyk, lepki pasek */
(() => {
  const zl = (cents) => {
    const v = cents / 100;
    return (Number.isInteger(v) ? v.toString() : v.toFixed(2).replace('.', ',')) + ' zł';
  };

  function initPdp(root) {
    if (root.dataset.drReady) return;
    root.dataset.drReady = '1';

    /* galeria: kropki na telefonie */
    const tor = root.querySelector('[data-dr-tor]');
    const kropki = root.querySelectorAll('[data-dr-kropki] button');
    if (tor && kropki.length) {
      kropki.forEach((b, i) => b.addEventListener('click', () => tor.scrollTo({ left: tor.clientWidth * i, behavior: 'smooth' })));
      let t;
      tor.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const i = Math.round(tor.scrollLeft / Math.max(1, tor.clientWidth));
          kropki.forEach((b, j) => b.classList.toggle('is-on', i === j));
        }, 60);
      }, { passive: true });
    }

    /* warianty (rozmiary) */
    let product = null;
    try { product = JSON.parse(root.querySelector('[data-dr-json]').textContent); } catch (e) {}
    const form = root.querySelector('[data-dr-form]');
    const idInput = root.querySelector('[data-dr-variant]');
    const atc = root.querySelector('[data-dr-atc]');
    const atcLabel = root.querySelector('[data-dr-atc-label]');
    const cena = root.querySelector('[data-dr-cena]');
    const cenaLepka = root.querySelector('[data-dr-cena-lepka]');
    const blad = root.querySelector('[data-dr-blad]');
    const optBtns = root.querySelectorAll('[data-dr-opt]');

    const current = () => product && product.variants.find(v => String(v.id) === idInput.value);
    const paint = (v) => {
      if (!v) return;
      idInput.value = v.id;
      cena.textContent = zl(v.price);
      if (cenaLepka) cenaLepka.textContent = zl(v.price);
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? `Dodaj do koszyka · ${zl(v.price)}` : 'Chwilowo niedostępny';
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    optBtns.forEach(btn => btn.addEventListener('click', () => {
      if (!product) return;
      const pos = +btn.dataset.drOpt;
      root.querySelectorAll(`[data-dr-opt="${pos}"]`).forEach(b => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      const lab = btn.closest('.dr-opcja')?.querySelector('[data-dr-wybrany]');
      if (lab) lab.textContent = btn.dataset.value;
      const sel = (current()?.options || []).slice();
      sel[pos] = btn.dataset.value;
      const v = product.variants.find(x => x.options.every((o, i) => o === sel[i]));
      paint(v);
    }));

    /* dodanie do koszyka */
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      blad.textContent = '';
      atc.disabled = true;
      const prev = atcLabel.textContent;
      atcLabel.textContent = 'Dodaję…';
      try {
        const ids = typeof window.drSectionIds === 'function' ? window.drSectionIds() : [];
        const body = { items: [{ id: +idInput.value, quantity: 1 }] };
        if (ids.length) body.sections = ids.join(',');
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Nie udało się dodać do koszyka.');
        atcLabel.textContent = 'Dodano ✓';
        document.dispatchEvent(new CustomEvent('dr:added', { detail: data }));
        if (typeof window.drAfterAdd === 'function') window.drAfterAdd(data);
        else window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (err) {
        blad.textContent = err.message;
        atcLabel.textContent = prev;
      } finally {
        setTimeout(() => { const v = current(); atc.disabled = v ? !v.available : false; if (atcLabel.textContent === 'Dodano ✓') atcLabel.textContent = prev; }, 1600);
      }
    });

    /* lepki pasek na telefonie */
    const lepki = root.querySelector('[data-dr-lepki]');
    const lepkiBtn = root.querySelector('[data-dr-lepki-btn]');
    if (lepki && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        lepki.classList.toggle('is-on', on);
        lepki.setAttribute('aria-hidden', on ? 'false' : 'true');
        lepkiBtn.tabIndex = on ? 0 : -1;
      }).observe(atc);
      lepkiBtn.addEventListener('click', () => {
        if (optBtns.length) atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else form.requestSubmit();
      });
    }
  }

  /* integracja z szufladą koszyka Horizon (Horizon 4.x: CartLinesUpdateEvent + morphSection) */
  const drRoot = () => window.Shopify?.routes?.root || '/';
  const drSectionIds = () => [...document.querySelectorAll('cart-items-component')].map(e => e.dataset.sectionId).filter(Boolean);
  window.drSectionIds = drSectionIds;
  if (typeof window.drAfterAdd !== 'function') {
    window.drAfterAdd = async (added) => {
      const drawer = document.getElementById('cart-drawer');
      const goCart = () => { window.location.href = drRoot() + 'cart'; };
      if (!drawer || typeof drawer.open !== 'function') { goCart(); return; }
      try {
        const ids = drSectionIds();
        let sections = added && added.sections && Object.keys(added.sections).length ? added.sections : null;
        if (!sections && ids.length) sections = await (await fetch(drRoot() + '?sections=' + ids.join(','))).json();
        const ajaxCart = await (await fetch(drRoot() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        const first = Array.isArray(added?.items) ? added.items[0] : added;
        /* licznik w nagłówku i inne komponenty motywu */
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const d = CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(first?.variant_id || first?.id || ''), quantity: first?.quantity || 1 }], promise: d.promise }));
          d.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart), detail: { items: ajaxCart.items, source: 'dr-pdp', sourceId: 'dr-pdp', itemCount: first?.quantity || 1, productId: first?.product_id, sections: sections || {}, didError: false } });
        } catch (e) { console.warn('[zloteserce] cart event', e); }
        /* zawartość szuflady */
        const { morphSection } = await import('@theme/section-renderer');
        for (const id of ids) if (sections && sections[id]) await morphSection(id, sections[id], { mode: 'hydration', injectStylesheet: true });
        setTimeout(() => { try { drawer.open(); } catch (e) { goCart(); } }, 120);
      } catch (err) {
        console.warn('[zloteserce] drawer refresh failed', err);
        goCart();
      }
    };
  }

  const boot = () => document.querySelectorAll('[data-dr-pdp]').forEach(initPdp);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
